const Mentions: Mention[] = [
  {
    src: 'https://si.keen.com/D1_homepage-brit2_V1.png',
    alt: 'BritCo',
    height: 24,
    width: 98
  },
  {
    src: 'https://si.keen.com/D1_homepage-cosmo2_V1.png',
    alt: 'Cosmo',
    height: 24,
    width: 123
  },
  {
    src: 'https://si.keen.com/D1_homepage-womenhealth2_V1.png',
    alt: 'WomenHealth',
    height: 24,
    width: 98
  },
  {
    src: 'https://si.keen.com/D1_homepage-yahoo2_V1.png',
    alt: 'Yahoo',
    height: 24,
    width: 86
  },
  {
    src: 'https://si.keen.com/D1_homepage-refinery2_V1.png',
    alt: 'Refinery',
    height: 24,
    width: 117
  },
  {
    src: 'https://si.keen.com/D1_homepage-bustle2_V1.png',
    alt: 'Bustle',
    height: 24,
    width: 76
  }
];

export default Mentions;
